export function generateEntityActionTypes(entityName) {
  return {
    ADD: `${entityName}/ADD`,
    CLEAN: `${entityName}/CLEAN`,
  };
}
